import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFileFromUrlPipe',
})
export class FormatFileFromUrlPipe implements PipeTransform {
  transform(url: string): unknown {
    if (!url) return null;
    const urlSplit: string[] = url.split('.');
    return urlSplit[urlSplit.length - 1];
  }
}
